import { Box } from "@mui/material";
import { EmojiAvatar } from "../../../../../modules/moment/component/emoji/emoji-view";
import { useMomentAnalyticsContext } from "../../context/moment-stats-context";

import type { Reaction } from "./types";
import type { FC } from "react";

export const ReactionAvatar: FC<{ reaction?: Reaction }> = ({ reaction }) => {
  const { emojiCache } = useMomentAnalyticsContext();

  if (!reaction) return null;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <EmojiAvatar
        emoji={reaction.emoji}
        emojiCacheEntry={emojiCache[reaction.emoji]}
        size="large"
      />
    </Box>
  );
};
